<script>
export default {
    props: {
        filterValues: {type: Array, required: true},
        values: {type: Array, required: false}
    },

    methods: {
        getFilterValues() {
            if (!Array.isArray(this.filterValues))
                return [this.filterValues]
            return this.filterValues

        },
        displayValue(val) {
            try {
                if (this.values)
                    return this.values.filter(item => item.id == val)[0].name
            } catch {}
            return val
        },
    },
}
</script>

<template>
  <span v-if="this.filterValues && this.filterValues.length">
  <span v-for="(v, index) in getFilterValues()" :key="index" class="badge badge-pill bg-light me-1">
    {{ displayValue(v) }}
    <a href="" class="text-decoration-none" @click.prevent="$emit('delete', v)">
        <i class="fas fa-times-circle"></i>
    </a>
  </span>
  </span>
</template>